const fail = [
  'https://i.kym-cdn.com/photos/images/original/000/613/716/41c.jpg',
  'https://sayingimages.com/wp-content/uploads/good-fail-meme.png',          
  'https://i.redd.it/d10a8ams69f21.png',          
  'https://media.giphy.com/media/3oz8xLd9DJq2l2VFtu/giphy.gif',          
  'https://media.giphy.com/media/Yth2zWqeTdqAo/giphy.gif',          
  'https://i.imgur.com/7IkBpQ5.gif',          
  'https://i.pinimg.com/originals/72/80/ee/7280eedf85ea5d674c22c5959d6e86cb.gif',          
  'https://cdn.vox-cdn.com/uploads/chorus_asset/file/8692949/no_words_homer_into_brush.gif',          
  'https://media1.giphy.com/media/3oFyDpijVlI0bSoB8Y/giphy.gif',          
  'https://media3.giphy.com/media/l1IY5J4Cfw8JLi40M/giphy.gif',          
  'https://media.giphy.com/media/ceeN6U57leAhi/giphy.gif',          
  'http://www.quickmeme.com/img/c1/c113dcffa98ea14ebafe0fe466e748db187912a1a3ed1307f350d457b10eaa2f.jpg',
  'https://i.imgflip.com/142vwg.jpg'          
]

export default fail